<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import FenixLogo from "./FenixLogo.vue";

const { t } = useI18n();

const footerLinks = computed(() => ({
  producto: [
    { label: t("landing.footer.product.features"), href: "#features" },
    { label: t("landing.footer.product.pricing"), href: "#pricing" },
    { label: t("landing.footer.product.demo"), href: "#" },
  ],
  empresa: [
    { label: t("landing.footer.company.about"), href: "#" },
    { label: t("landing.footer.company.security"), href: "#" },
    { label: t("landing.footer.company.compliance"), href: "#" },
  ],
  contacto: [
    { label: t("landing.footer.contact.support"), href: "#" },
    { label: t("landing.footer.contact.sales"), href: "#" },
    { label: t("landing.footer.contact.docs"), href: "#" },
  ],
}));
</script>

<template>
  <footer id="contact" class="bg-background border-t border-border/30 scroll-mt-20">
    <div class="container mx-auto px-6 py-16">
      <div class="grid md:grid-cols-4 gap-12 lg:gap-16">
        <!-- Logo and tagline -->
        <div class="md:col-span-1">
          <FenixLogo size="xl" class="mb-4" />
          <p class="text-sm text-muted-foreground mt-4">
            {{ t("landing.footer.tagline") }}
          </p>
        </div>

        <!-- Producto -->
        <div>
          <h4 class="text-sm font-semibold text-foreground mb-4">
            {{ t("landing.footer.product.heading") }}
          </h4>
          <ul class="space-y-3">
            <li v-for="(link, i) in footerLinks.producto" :key="i">
              <a 
                :href="link.href"
                class="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Empresa -->
        <div>
          <h4 class="text-sm font-semibold text-foreground mb-4">
            {{ t("landing.footer.company.heading") }}
          </h4>
          <ul class="space-y-3">
            <li v-for="(link, i) in footerLinks.empresa" :key="i">
              <a 
                :href="link.href"
                class="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Contacto -->
        <div>
          <h4 class="text-sm font-semibold text-foreground mb-4">
            {{ t("landing.footer.contact.heading") }}
          </h4>
          <ul class="space-y-3">
            <li v-for="(link, i) in footerLinks.contacto" :key="i">
              <a 
                :href="link.href"
                class="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Bottom bar -->
      <div class="mt-16 pt-8 border-t border-border/20">
        <p class="text-xs text-muted-foreground text-center">
          {{ t("landing.footer.copyright") }}
        </p>
      </div>
    </div>
  </footer>
</template>
